import { render, staticRenderFns } from "./PodiumCardDefault.vue?vue&type=template&id=1ba9cd2e&scoped=true"
import script from "./PodiumCardDefault.vue?vue&type=script&lang=js"
export * from "./PodiumCardDefault.vue?vue&type=script&lang=js"
import style0 from "./PodiumCardDefault.vue?vue&type=style&index=0&id=1ba9cd2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba9cd2e",
  null
  
)

export default component.exports